module.exports = __webpack_public_path__ + "img/bg_product_item.00795c6f.png";